var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4.92308C11.25 5.33729 11.5858 5.67308 12 5.67308C12.4142 5.67308 12.75 5.33729 12.75 4.92308V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.75C7.44365 9.75 3.75 13.4437 3.75 18C3.75 18.4142 3.41421 18.75 3 18.75C2.58579 18.75 2.25 18.4142 2.25 18C2.25 12.6152 6.61522 8.25 12 8.25C17.3848 8.25 21.75 12.6152 21.75 18C21.75 18.4142 21.4142 18.75 21 18.75C20.5858 18.75 20.25 18.4142 20.25 18C20.25 13.4437 16.5563 9.75 12 9.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18C8 15.7909 9.79086 14 12 14C14.2091 14 16 15.7909 16 18Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46967 5.46967C1.76256 5.17678 2.23744 5.17678 2.53033 5.46967L4.53033 7.46967C4.82322 7.76256 4.82322 8.23744 4.53033 8.53033C4.23744 8.82322 3.76256 8.82322 3.46967 8.53033L1.46967 6.53033C1.17678 6.23744 1.17678 5.76256 1.46967 5.46967Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5303 6.53033C22.8232 6.23744 22.8232 5.76256 22.5303 5.46967C22.2374 5.17678 21.7626 5.17678 21.4697 5.46967L19.4697 7.46967C19.1768 7.76256 19.1768 8.23744 19.4697 8.53033C19.7626 8.82322 20.2374 8.82322 20.5303 8.53033L22.5303 6.53033Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeAlt1);
export default __webpack_public_path__ + "static/media/eye-alt-1.a84c79d31e1fc78615fabca07fc53224.svg";
export { ForwardRef as ReactComponent };